import React from "react";
import {
  CustomerSocketActionsType,
  CustomerSocketStateSelectorType,
  useCustomerSocketActions,
  useCustomerSocketState
} from "./hooks";

type MapCustomerSocketActionsType = (actions: CustomerSocketActionsType) => any;

export const withCustomerSocket = (
  mapSocketStateToProps?: CustomerSocketStateSelectorType,
  mapSocketActionsToProps?: MapCustomerSocketActionsType
) => (BaseComponent: React.Component) => (props: any) => {
  const socketState = useCustomerSocketState(mapSocketStateToProps);
  const socketActions = useCustomerSocketActions();
  return (
  // @ts-ignore
    <BaseComponent
      {...props}
      {...(mapSocketStateToProps ? socketState : {})}
      {...(mapSocketActionsToProps ? mapSocketActionsToProps(socketActions) : {})}
    />
  )
}

